module.exports = __webpack_public_path__ + "img/ambu-bag.293266a4.jpg";